import { render, staticRenderFns } from "./allowCreate-editor.vue?vue&type=template&id=26eb7b32&scoped=true"
import script from "./allowCreate-editor.vue?vue&type=script&lang=js"
export * from "./allowCreate-editor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26eb7b32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26eb7b32')) {
      api.createRecord('26eb7b32', component.options)
    } else {
      api.reload('26eb7b32', component.options)
    }
    module.hot.accept("./allowCreate-editor.vue?vue&type=template&id=26eb7b32&scoped=true", function () {
      api.rerender('26eb7b32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/setting-panel/property-editor/allowCreate-editor.vue"
export default component.exports